import React, { useRef } from 'react';
import './TeamSection.css';
import { Link } from 'react-router-dom';
import { motion, useInView } from 'framer-motion';
import { isIOS } from '../../hooks/isIos';

export function TeamSection() {
	const ref = useRef(null);
	const marginValue = isIOS() ? '0px' : '-350px';
	const isInView = useInView(ref, { once: true, margin: marginValue });

	const teamStats = [
		{ number: '4', label: 'Entwickler:innen' },
		{ number: '1', label: 'Ziel' },
		{ number: '100%', label: 'Motivation' },
		{ number: '∞', label: 'Ideen' },
	];

	const teamValues = [
		'Datenschutz steht bei uns an erster Stelle – eure Daten gehören euch.',
		'Benutzerfreundlichkeit für jede Altersgruppe – intuitiv und klar.',
		'Transparente Kommunikation – offen und ehrlich.',
		'Familienorientierte Entwicklung – mit echten Bedürfnissen im Fokus.',
		'Ständige Weiterentwicklung durch echtes Nutzerfeedback.',
	];

	return (
		<section className='team-section' ref={ref}>
			<motion.h1
				className='section-title'
				initial={{ opacity: 0, y: 20 }}
				animate={isInView ? { opacity: 1, y: 0 } : {}}
				transition={{ duration: 0.6 }}
			>
				Das <span style={{ color: '#6C5CE7' }}>Team</span> hinter Erledix
			</motion.h1>

			<motion.p
				className='team-description'
				initial={{ opacity: 0, y: 20 }}
				animate={isInView ? { opacity: 1, y: 0 } : {}}
				transition={{ delay: 0.1, duration: 0.5 }}
			>
				Wir sind ein leidenschaftliches Team von Entwickler:innen, die gemeinsam an einer
				klaren Vision arbeiten:
			</motion.p>

			<motion.p
				style={{ color: '#6C5CE7', fontStyle: 'italic', fontSize: '1.5rem' }}
				initial={{ opacity: 0, y: 20 }}
				animate={isInView ? { opacity: 1, y: 0 } : {}}
				transition={{ delay: 0.2, duration: 0.5 }}
			>
				Den Familienalltag einfacher und gerechter machen.
			</motion.p>

			<div className='team-stats'>
				{teamStats.map((stat, index) => (
					<motion.div
						className='team-card'
						key={index}
						initial={{ opacity: 0, y: 30 }}
						animate={isInView ? { opacity: 1, y: 0 } : {}}
						transition={{
							delay: 0.3 + index * 0.15,
							duration: 0.5,
							ease: 'easeOut',
						}}
					>
						<h2 className='stat-number'>{stat.number}</h2>
						<p className='stat-label'>{stat.label}</p>
					</motion.div>
				))}
			</div>

			<ul className='team-values'>
				{teamValues.map((value, index) => (
					<motion.li
						key={index}
						initial={{ opacity: 0, y: 20 }}
						animate={isInView ? { opacity: 1, y: 0 } : {}}
						transition={{
							delay: 0.3 + teamStats.length * 0.15 + index * 0.15,
							duration: 0.4,
						}}
					>
						{value
							.split(
								/(Datenschutz|Benutzerfreundlichkeit|Kommunikation|Familienorientierte|Nutzerfeedback)/
							)
							.map((part, i) =>
								[
									'Datenschutz',
									'Benutzerfreundlichkeit',
									'Kommunikation',
									'Familienorientierte',
									'Nutzerfeedback',
								].includes(part) ? (
									<span key={i} style={{ color: '#6C5CE7', fontWeight: 'bold' }}>
										{part}
									</span>
								) : (
									part
								)
							)}
					</motion.li>
				))}
			</ul>

			<motion.div
				initial={{ opacity: 0, y: 20 }}
				animate={isInView ? { opacity: 1, y: 0 } : {}}
				transition={{
					delay: 0.3 + teamStats.length * 0.15 + teamValues.length * 0.15 + 0.2,
					duration: 0.5,
				}}
			>
				<Link to='/beta-signup' className='cta-button'>
					Hilf uns dabei, Erledix zu verbessern und werde Teil unserer Community!
				</Link>
			</motion.div>
		</section>
	);
}
